// extracted by mini-css-extract-plugin
export default {"MainChatInterface":"MessagingInterface_MainChatInterface__Nny0w"};